import { render, staticRenderFns } from "./showcase.vue?vue&type=template&id=7f853c5f&scoped=true&"
import script from "./showcase.ts?vue&type=script&lang=ts&"
export * from "./showcase.ts?vue&type=script&lang=ts&"
import style0 from "./showcase.scss?vue&type=style&index=0&id=7f853c5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f853c5f",
  null
  
)

export default component.exports